import angular from 'angular';
import adminToolSectionComponent from './adminToolSection.component';
import adminToolSectionService from './adminToolSection.service';



let adminToolSectionModule = angular.module('adminToolSection', [])
  .component('adminToolSection', adminToolSectionComponent)
  .service('adminToolSectionService', adminToolSectionService);

export default adminToolSectionModule;



// WEBPACK FOOTER //
// ./app/components/adminToolSection/adminToolSection.js